import { Box, Skeleton, Typography } from "@mui/material";
import type { AmountDto } from "Infrastructure/Api/Api";
import type { CurrencyCode } from "Models/CurrencyCodes";
import { formatCurrency } from "Utils/CurrencyUtils";

type Props = {
  amounts: Array<AmountDto>;
  emptyStateCurrency?: CurrencyCode;
  isLoading?: boolean;
  title: string;
  colorVariant?: "success" | "warning" | "error";
};

export const BaseTransactionFeesTab = ({
  amounts,
  emptyStateCurrency,
  isLoading,
  title,
  colorVariant = "success",
}: Props) => {
  // The API returns one entry per currency; amounts must never be summed across
  // currencies, so each entry renders as its own value.
  const displayAmounts: Array<{ value: number; currencyCode?: string }> =
    amounts.length > 0
      ? amounts
      : [{ value: 0, currencyCode: emptyStateCurrency }];

  return (
    <Box display="flex" gap={2}>
      <Typography fontSize="0.875rem" gutterBottom>
        {title}
      </Typography>
      <Box display="flex" gap={2} alignItems="baseline">
        {isLoading ? (
          <Typography color={colorVariant}>
            <Skeleton width={140} />
          </Typography>
        ) : (
          displayAmounts.map(({ value, currencyCode }) => (
            <Typography key={currencyCode ?? "unknown"} color={colorVariant}>
              {formatCurrency({
                amount: value,
                currencyCode,
                maxDecimalPlaces: 2,
              })}
            </Typography>
          ))
        )}
      </Box>
    </Box>
  );
};
